
export default function videoModal() {

  document.querySelectorAll('.full-width-photo__video, .full-width-photo-bg__video').forEach(el => {
    el.addEventListener('click', function (e) {


      var player = document.getElementById('video-player');
      player.setAttribute('src', player.dataset.src);

      /*document.querySelectorAll('.yt_player_iframe').forEach(el => {
        el.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
      });*/

      /*var cld = cloudinary.Cloudinary.new({ cloud_name: 'dmh15ov9z' });
      var demoplayer = cld.videoPlayer('doc-player').width(600);
      demoplayer.source('stock%20plans/Stockcross_CorporateOffice-VideoC_wejnxd')*/

      /*var cld = cloudinary.Cloudinary.new({ cloud_name: 'demo' });
      var demoplayer = cld.videoPlayer('doc-player').width(600);
      demoplayer.source('race_road_car')*/


      document.getElementById(el.getAttribute('data-video')).classList.add('open');

      document.querySelectorAll('body').forEach(el => {
        el.classList.add('modal-open');
      });
    });
	});


  document.querySelectorAll('.full-width-photo__video-modal-content-wrap, .full-width-photo-bg__video-modal-content-wrap').forEach(el => {
    el.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });



  document.querySelectorAll('.full-width-photo__video-modal, .full-width-photo-bg__video-modal').forEach(el => {
    el.addEventListener('click', function (e) {
      e.stopPropagation();


      el.classList.remove('open');
      el.classList.add('fade-out');

      /*document.querySelectorAll('.yt_player_iframe').forEach(el => {
        el.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
      });*/

      var player = document.getElementById('video-player');
      player.setAttribute('src', '');

      document.querySelectorAll('body').forEach(el => {
        el.classList.remove('modal-open');
      });
    });
	});




}
